// removed by extract-text-webpack-plugin
module.exports = {"root":"AutosuggestVinVehicle-module-root-1NYJ-","cross-btn":"AutosuggestVinVehicle-module-cross-btn-2G9rY","crossBtn":"AutosuggestVinVehicle-module-cross-btn-2G9rY","home":"AutosuggestVinVehicle-module-home-3bMq2","hint":"AutosuggestVinVehicle-module-hint-3Ebnu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AutosuggestVinVehicle/AutosuggestVinVehicle.module.scss
// module id = 1044
// module chunks = 0